import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AddGlobalRateLimitModal } from '../modals/add-global-ratelimit/add-global-ratelimit.component';
import { SharedService } from '../services/shared-service.service';

@Component({
  selector: 'rate-limit',
  templateUrl: './rate-limit.component.html',
  styleUrls: ['./rate-limit.component.scss'],
})
export class RateLimitComponent implements OnInit {
  showAddCountryButton = false;
  routeSubscription = Subscription;

  constructor(
    private location: Location,
    private router: Router,
    private modalService: SuiModalService,
    private sharedService: SharedService
  ) {
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        let url = this.location.path().split('/');
        if (url[url.length - 1] === 'global-profile-setting') {
          this.showAddCountryButton = true;
        } else {
          this.showAddCountryButton = false;
        }
      }
    });
  }
  goBack() {
    this.router.navigate(['/admin/setting/application-security']);
  }

  ngOnInit(): void {}

  addCountry() {
    this.modalService
      .open(new AddGlobalRateLimitModal('Add Global Rate Limit', {}))
      .onApprove(() => {
        this.sharedService.updateDate(true);
      })
      .onDeny(() => {
        this.sharedService.updateDate(true);
      });
  }
}
